module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch01"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Chapter One")])])])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_c('span', {
    staticClass: "chapterOpenerFirstLetters"
  }, [_c('span', [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("“O")])])])]), _vm._v("h, no!”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The cry jarred Rona Meyers from her contemplation too late to escape the hot liquid that seeped through her pant leg as the waitress hit the floor along with the silverware. With customers’ exclamations ringing in her ears, Rona scooted from the bench to help with the mess, but a man in a nearby booth had scrambled up first.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Of all the men present, he’d been the only one to come to the waitress’s rescue and Rona admired the man’s gallantry. The more she looked, the more she admired him. His rugged handsomeness, his tanned face and his brawny stature caused him to stand out among the others present.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("With his help, the waitress rose, her face glowing the color of a ripening apple while she still clutched the empty tray. With tears rolling down her cheeks, she ran behind the counter and through the door into the kitchen, leaving behind the mess of broken china and uneaten food.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Feeling distress for the young woman, Rona watched the intriguing man return to his booth before focusing on the dark spots soiling her otherwise clean beige pants. She grasped a paper napkin and daubed the stain, grateful the coffee had only been hot and not scalding.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("When she looked up, the gentleman was eyeing her as if to acknowledge she’d tried to help the waitress, too. Rona gave him a feeble grin and looked away, uneasy with his obvious attention and hoping he hadn’t noticed her gaping at him.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The kitchen door remained closed and Rona watched it to see what would happen now. Would the young woman regain her composure and return to clean up the mess, or would she sulk for a while in the back room?")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Rona had experienced the same feelings. Being a waitress wasn’t easy. The recollection settled into her mind—the hard work, low wages and the sometimes tip-less tables that she’d found so discouraging.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Ridding herself of the memory, Rona gazed out the window at the sun glinting against Lake Huron on Michigan’s north shore. The muted silvery gold streak rippled like the yellow line on the highway through the rain—or through tears.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("A short distance across the lake one of the Les Cheneaux Islands rose above the water, its shoreline thick with trees and dotted by an occasional home—large homes with elaborate two-storied boathouses. She’d noticed the island on trips to the area with her friend Janie, who’d come to Hessel to visit her aunt. The memory had remained and had drawn her back here now when she needed to get away from her disturbing life.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Distant voices came from the kitchen; Rona watched the door, but the voices only grew louder. She looked away and noticed the stranger watching her again. He sent her a wide smile that made his eyes crinkle. His hair looked tousled. If he’d stop looking at her, she would enjoy looking at him.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Finally the kitchen voices silenced. The door swung open and a tall, lanky man charged behind the counter pulling meals from the serving window and scanning the crowded tables. He studied the tickets, then gave a nod as if he’d discovered his answer and slid the dishes up his arm and headed to a table across the room. He wore an apron, so she assumed he was a cook. This appearance brought an obvious question into her head. Where was the waitress?")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Rona followed the man’s journey with her eyes, watching him hand over the dishes with skill, then head back toward the kitchen. As he passed, the good-looking man’s hand shot out and nabbed the cook.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Curious, she leaned closer, hoping to hear the conversation, but his soft voice didn’t carry.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The cook’s did.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“She quit, Nick,” he said, his arm swinging toward the kitchen door. “Walked out the back door screaming that she hated the job. Now I’m really shorthanded. No busboy today, either.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Shorthanded.")])]), _vm._v(" The word skittered down Rona’s spine, worked its way into her head. Her throat tightened with the words that formed in her mind.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Nick gave the cook’s arm a pat along with what appeared to be a look of encouragement, then his gaze captured hers again and her stomach twisted.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Nick reminded her of a lumberjack. She could picture his broad shoulders and wide chest pivoting as his powerful arms swung an ax. She couldn’t help but think of Michigan’s legendary lumberman Paul Bunyan. The name Nick “Bunyan” came to mind and she grinned.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("When she focused, Nick Bunyan was smiling back at her. She wanted to sink into her seat. Instead, she turned her eyes on the cook as he headed her way.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Sir,” she said, keeping her voice low while hoping he heard her.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The cook glanced at her without really looking. “I’ll get your bill in a minute. I’m short a waitress.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Though she’d tried to hold them back, her need caused words to fly from her mouth. “I’ve done waitressing.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Her comment jerked him to a stop. “You what?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I’ve been a waitress. If you need someone, I’ll give you a hand.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("His surprised look shrunk to a frown. “You’re willing to fill in for Gerri? You’re pulling my leg.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“No. I’m new in town and need a job. One day’s work is better than nothing.” Her heart rose to her throat.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("His jaw sagged as he seemed to contemplate what she’d said.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Looking at his expression, she wondered why she’d opened her mouth. Waitressing wasn’t her favorite work, but if he liked her, it could mean a start in the new town. She’d look for something more suitable after she had settled. Her meager bank account wouldn’t last forever.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Butcher,” he said.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Butcher?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“My name. Bernie Butcher. Quite a mouthful, don’t you think?” He motioned for her to follow without giving her a moment to introduce herself.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Rona grabbed her shoulder bag, rose and dropped the paper napkin on the table. She stepped around the mess on the floor, not wanting to find herself flattened against the abandoned burger and ketchup-laden fries.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The kitchen door had begun to swing close, but she caught it and stepped inside, assailed by the odor of grease and heat from the griddle and frier.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Bernie—Mr. Butcher—gestured her across the room to a doorway. He followed, pushing open the door of a small storage area. “Put your belongings in here and grab an apron.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She tucked her handbag into a niche and pulled an apron from a hook, then tied it around her waist. As she turned back and reached for the doorknob, she spotted a floor plan of the Harbor Inn’s seating arrangement and table stations. She studied it a moment, hoping she could remember which table was which.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("While pride railed her for offering to help, common sense led her to the cook rather than following Gerri’s path and escaping out the door. “By the way, my name’s—”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Food’s up for table six.” He pointed to the dishes lining the warming window.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Her head whirling, she read the ticket, recalled the floor plan and carried the food to the table she hoped was number six. As she approached, the diners’ expressions let her know she’d made a good guess.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Here you go,” she said, balancing the plates as she removed them from her arm. “I’m sorry for the wait.” She eyed their near empty cups. “I’ll be right back with fresh coffee and some ketchup.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The customers nodded and dove into their food while she scurried away to bring back the items. Her waitress skills popped into her consciousness. She refreshed their coffee, then put on a new pot and headed for two new arrivals.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("When she placed their order, she grabbed the next ticket. Table three. The floor plan shot into her mind. Nick Bunyan. She gazed at the whitefish sandwich with a dollop of slaw on the side. Healthier than fries or a greasy burger. She pictured him swinging the ax as her unsteady hand grasped the plate.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Rona avoided his gaze as she crossed the floor to him, realizing someone had cleaned up the fallen mess. She slid the plate in front of him. “I’ll bring you a refill. Decaf or regular?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Regular, and nice job.” He tilted his head toward the kitchen.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("His comment caught her off guard. “Thanks,” she said, trying to avoid his eyes. But he touched her arm and she had to look.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He gave her a faint smile. “Black.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Black? The word hung in the air until she remembered the coffee. “I’ll be right back.” His grin unsettled her, though she knew she was being silly. Most people in a small town recognized a stranger and she was a stranger.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("After filling his cup, she took other orders and refreshed drinks, avoiding him; but drawn by curiosity, she couldn’t help but glance his way. She saw him sipping the coffee and scanning a newspaper.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("His gaze lifted from the paper to hers.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He’d caught her gaping again. Rona looked away as if she hadn’t noticed. She’d come to Michigan’s upper peninsula to get away from her past and keep a low profile, but she hadn’t done a very good job today. She’d lived so much on the edge of stress, tension knotted in her again.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Foolish. He was a good-looking man, a kind man, she reminded herself. He meant nothing by his stare. New in town, she was a curiosity.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She concentrated on her work, took orders and bussed tables, wondering why Butcher or Bernie, whatever she was supposed to call him, hadn’t hired more help. She would certainly earn her wage today—whatever it was. She’d forgotten to ask.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Rona zipped past Nick and pushed a utility cart filled with dirty dishes through the kitchen door. The lunch crowd had slowed and she stood a moment to get her bearings.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Bernie pulled out a basket of fries to drain and headed her way. “You’re a lifesaver.” He wiped his hand on his apron and stuck it out toward her. “And a good one.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Thank you.” She grinned at his overdone welcome. “I’m Rona Meyers, in case you want to know who’s worked here for the last two hours.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Sorry.” He lowered his head as if realizing what he’d done. “I own the place and when things go wrong, I lose my cool. My busboy called in sick and then Gerri quit. What I need is good steady help.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She could be good steady help, but he didn’t know her and she was certain he wouldn’t hire a stranger. She only nodded at his complaints.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Mandy should be here in another hour, and Jimmy’ll bus.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Then I’ll keep going until someone shows up.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He’d turned away, and she was left feeling empty again. For two hours she’d had a purpose, even if it was only waitressing, but it appeared that in a couple of hours, it would be over. She’d find work somewhere.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Rona snatched an empty cart, pulled it into the dining room and parked it beside the counter, then grabbed the coffeepot. When she turned, she felt her heart sink a little. Nick’s table was empty, but he’d left her a five dollar tip—more than she deserved.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("What did she care except he’d added a little excitement to her life. She grimaced, recalling excitement was what she wanted to escape.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The next hour flew past, and when a cute blond woman came in through the back door, Rona assumed she was Mandy. The woman gave her a strange look as if to ask what was she doing in the kitchen.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Gerri quit,” Bernie said, apparently noticing her questioning look.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Oh.” She moved closer. “You’re the new waitress?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She wished. “I’m Rona. Just filling in.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Her scowl turned to a smile as she extended her hand. “I’m Mandy.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Rona shook her hand, then glanced at the clock. “Guess I can get on my way.” She eyed Bernie, waiting for him to offer to pay her.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Instead, he pointed toward the warmer. “Can you catch that?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She scooted back through the door, grabbed the two fish platters, then stopped in her tracks. After only an hour, Nick had returned. Rona veered in the other direction and set the plates in front of two men deep in conversation.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Before she took another step, Nick flagged her to his table. “Mandy will catch your order. She’ll be out in a moment.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I’d like to talk with you for a minute if you don’t mind.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("A frown tightened her forehead. “Me?” She poked her index finger against her chest, sensing he was coming on to her.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He nodded. “When you’re finished.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She eyed him a moment. “If you think—”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I’m not thinking anything.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He grinned and her concern eased, but it didn’t stop her questions. What did he want? Why had he come back?")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("His good looks melded with her curiosity and she realized she’d assumed the negative without using good sense. She’d come here to escape her unhappy life and now she realized she’d brought the fears along with her.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Without answering him, Rona shot back into the kitchen, longing to know what the man wanted, but thinking it might be best to leave through the back door. Before Bernie asked her to do anything else, she slipped off her apron, strode to the storage room and hung it on the hook where she’d found it. She pulled her shoulder bag from the niche and drew in a deep breath.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Gaining composure, Rona walked back into the kitchen. “I’m leaving,” she said, waiting for Bernie to acknowledge her.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He finally glanced at the wall clock, then turned his head to look at her. “We’re still short help. Why don’t you stick around until five.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Until five?” If staying meant the possibility of being offered the job, she needed to use wisdom. “Okay.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Family here?” He shuffled his feet as if he were hedging.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“No family. I knew the Baileys who live in Hessel. It was years ago, when I was a kid, and I always had good memories of the Les Cheneaux area.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“When you were a kid?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He studied her as if wondering why it had taken her so long to return to the area. At thirty-nine, she was far from a kid.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("His jaw twitched as his eyebrows raised. “You mean Sam and Shirley Bailey?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She nodded.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Sam died last year, but Shirley’s still in the same place.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Sam died. She remembered the friendly man who had been Janie’s grandfather.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“You’re only just visitin’ then.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Now Rona shuffled her feet as uncertainty winged its way into her thoughts, but she’d made a life change and she would honor her plans. “I’m staying.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“You did a good job today pinch-hittin’ like that.” He shuffled his feet again. “Lookin’ for work?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("His question raised her spirits. She gave a halfhearted shrug. “Actually, yes, but—”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I’d like you to stay on. You worked hard and I respect that.” He smiled a toothy grin. “Plus, you surprised me making that offer to help and I surprised myself by accepting it. I don’t know you from Adam.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She couldn’t help but grin back. “I saw you were in a bind.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I can give you six dollars an hour plus your tips,” he said, shifting closer and keeping his volume just above a whisper. “I know that’s not a fortune, but we have good tippers around here. For good service, that is.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She pictured Nick’s five dollar tip. Six dollars an hour. Good tips. She remembered working for two-seventy-five plus tips. Rona did a quick calculation. Not a bad wage until she found something better. “I can give it a try.” She paused knowing she had to be honest. “But if something better comes along, I make no guarantees.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He pondered her comment, probably knowing that not much else was available around the area. “You got yourself a deal.” He stuck out his hand and gave hers a shake.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Bernie held up a finger. “I’ll get you an application.” He strode into the storage room and out again with the forms. “You can sit at a table and fill these out and, while you’re at it, grab a bite to eat. I imagine you’re hungry.” He handed her the papers.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Sit at a table.")])]), _vm._v(" So much for her back-door escape, and by now she didn’t want to. She was hungry and a free meal sounded good. She ordered a whitefish sandwich—Nick’s had looked good earlier in the day—then poured herself a cup of coffee and headed into the dining room.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Her gaze drifted to Nick, who had once again focused on the newspaper, sipping a cup of coffee that Mandy must have brought to him. He was leaning his shoulder against the wall and she guessed he was waiting for her. She still hadn’t figured out the reason he wanted to talk to her. She eyed him, then decided she might as well get it over with.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Rona bit her lips, knowing she was lying to herself. Getting it over with had nothing to do with her motivation. The man had captured her interest. Still she didn’t want the guy to get the wrong idea.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Grasping the application and her coffee mug, she ambled to his table vacillating between interest and indecision. “Sorry.” She waved the forms toward him and motioned to an empty seat. “Bernie asked me to fill out these forms so I’ll sit—”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“You can fill them out here.” He patted the space across from him. “I don’t bite.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Her old uneasiness soared into her chest. He said he didn’t bite, but she was too gullible. Even her own brother had conned her into making a decision she lived to regret. She knew her brother, but what did she know about Nick? Wavering with indecision, Rona could feel the stress in her face.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Please,” he said, his tone warm and genial.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She slid her cup onto the table and placed the application farther away, fearing she would stain them with her coffee. Her hands felt unsteady as she settled onto the chair.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Fish sandwich’s ready.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Hearing the voice, she turned and saw Bernie slide her dinner under the warmer. She halted Nick with her index finger and hurried to the serving window for her sandwich.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("When she’d settled back on the chair, Nick gave the bun a coy grin. “Looks familiar.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("His lighthearted tone brightened her spirit. “You had one earlier, I know. It looked good.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“It was.” He gazed at her and she felt heat rise up her neck. Get a grip, she told herself, embarrassed that she’d allowed this stranger to wheedle his way into her life. She’d been duped before and though he said he wasn’t thinking anything, how could she trust him? Maybe he was trying to pick her up. What kind of woman did he think she was? She’d always been too trusting, too unsuspecting, and it was time to change. She steadied herself and peered into his eyes. “I don’t understand why you want to talk with me.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I don’t, either,” he said, the same crooked grin spreading to his lips. “I’m curious, I guess.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Curious?” His words skittered up her spine. “About what?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“About you. What made you volunteer to wait tables? I’ve seen waitresses blow their corks and dart off, but I’ve never seen a customer stand up and take over.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I’ve worked as a waitress.” She felt the heat in her cheeks deepen. “Are you telling me you came back here because you were curious?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("His gaze drifted out the window, then back to her. “My son has track practice and I’m waiting for him.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Son.")])]), _vm._v(" Then he was married. Embarrassed at her presumption, she lowered her eyes to his left hand. No ring. Did lumberjacks wear rings?")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“You’re a good dad to pick up your son from school.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Nick’s mouth twisted.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She’d never had her dad pick her up from anywhere, but then she’d been grateful he didn’t. So often he was drunk.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“He doesn’t have his runabout today and we live on the island.” He tilted his head toward the window.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She followed his nod toward the island across the lake, filled with lovely houses bordered by acres of thickly wooded land. Privacy. Elegance.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I was at a contractor’s meeting in town and it was convenient.” He gazed out the window toward the water and the look on his face made her wonder.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Convenient? She sensed he was dismissing her “good father” comment. “It’s still nice.” Rona pulled her gaze from the window back to him, her memory drifting back to an earlier comment. “You had a contractor’s meeting. Then, you’re in construction?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He fingered his coffee mug. “Yes, and I own a resort on Drummond Island, up the road a few miles.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Construction, owns a resort—the man had to be wealthy. Her earlier lumberjack image vanished and she winced at her simplistic perception.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Her focus lowered to the table and the job application. For some reason she felt guilty. “I guessed you for a lumberjack.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He chuckled. “No, but my family once owned a logging company years ago.” He offered her his hand. “My name’s Nick Thornton.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Thornton.")])]), _vm._v(" She felt another grin settle on her face. So much for Bunyan. She grasped his fingers. “I’m Rona Meyers.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He studied her face while she waited for him to say something. Anything.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Finally he gestured to the forms she’d pushed against the wall. “Job application?” His expression had changed so quickly to a frown.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She studied him without responding. His smile didn’t return. “I need a job and Bernie offered. I figured I’d take it until something else comes along.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He drew back, his scowl deepening.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The look threw her. What did he care? “I was honest with Bernie. I told him no guarantee. He still offered me work as long as I want. I don’t suppose I’ll find much else in a small town like this, anyway.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He shifted her application form with his index finger. “There’s work if you know where to look.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She studied his face, waiting for him to continue.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Silence fell between them again until she felt forced to speak. “Where should I look?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“At me.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“At you?” She enjoyed looking at him. He had a great smile, good looks and a playful personality—if she felt like playing games, which she didn’t right now. “What does that mean?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Doesn’t matter. It’s too late. You’ve found your own job.” He lifted a newspaper from the chair beside him and slid it on the table, glanced at his watch and rose. “Gary’s probably waiting. I’d better get.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He dropped two dollars on the table and took a step away before pivoting to face her again. “Nice to meet you, Rona,” he said, walking backward.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She watched him swing through the front door and felt very alone. He appeared outside the window, crossed the street and headed along the sidewalk beside the marina. Then he vanished from her sight.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The application lay beside her hand, and she eyed it while her mind soared back to her situation in Eastpointe when she’d been so naive. She’d had a number of bad relationships and now, with maturity, she was trying to decipher why she’d had such poor judgment. She trusted people too easily—that had been her discovery. The memory edged against her heart and the loneliness grew. She’d come here, knowing no one, really. Shirley Bailey probably wouldn’t remember her.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Her coffee had cooled, but she took a last drink, trying to focus on her new life here in Les Cheneaux area—in Hessel. When the desolate feeling passed, she shifted her attention from the application to the newspaper.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Drawing it closer, she turned it to face her. Odd. Nick had left it open to employment ads. She skimmed the list until she spotted Nick’s name. Her pulse tripped as she read the ad.")])]), _c('div', {
    staticClass: "extract",
    staticStyle: {
      "margin-left": "5%"
    }
  }, [_c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_vm._v("Housekeeper needed on Marquette Island.")])]), _c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_vm._v("Transportation provided. Good pay.")])]), _c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_vm._v("Room and board.")])]), _c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_vm._v("Contact Nick Thornton.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Transportation provided? With no bridge or ferry, that made sense. She studied his telephone number while her heart sank. Room and board. Good pay and an island. She’d be safer there.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("But she didn’t know Nick Thornton. Could she trust him? She’d be alone on an island with a man she didn’t know. She rubbed her temples, then grinned. Could she trust herself?")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-84e347b4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/familyinhisheart_ch01.vue
// module id = 66
// module chunks = 0